module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/brand-design-east-works.json
// module id = 406
// module chunks = 23418452685258